import { useMiscContentDetailsPageData } from 'src/app/pages/misc/pageContext';

type Result = ModelHookResult<{
	content: string;
	styles: string;
}>;

export function usePageBody(): Result {
	const {
		data: {
			details: { content, css },
		},
	} = useMiscContentDetailsPageData();

	return {
		data: {
			content,
			styles: css,
		},
	};
}
